import { useState, useEffect } from "react";
import { Box, Button, CardMedia, Card, TextField } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeLanding } from "./UseHomeLanding";
import LandingItems from "./LandingItems";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function EditLanding(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const navigate = useNavigate();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetLandingByID } = UseHomeLanding();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const { validate, updateLandingBox } = UseHomeLanding();
  const [offers, setOffers] = useState();
  const [items, setItems] = useState();
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState({
    id: undefined,
    aid: undefined,
    panelNO: undefined,
    title: undefined,
    description: undefined,
    moreTitle: undefined,
    moreURL: undefined,
  });

  const [imgState, setImgState] = useState({
    file: "",
    url: state.icon ? state.icon : "",
  });

  useEffect(() => {
    if (location.state && location.state.LanID) {
      GetLandingByID(location.state.LanID, (callback) => {
        setState({
          id: callback.id,
          aid: callback.aid,
          panelNO: callback.panelNO,
          title: callback.title,
          description: callback.description,
          moreTitle: callback.moreTitle,
          moreURL: callback.moreURL,
        });
        setItems(callback.items);
        setImgState({
          file: undefined,
          url: callback.icon ? callback.icon : "",
        });
      });
    }
  }, [location.state]);

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/LandingsManage",
            LandingID: location.state.LandingID && location.state.LandingID,
            componentFaTitle: location.state.componentFaTitle,
          },
          {
            name: "ویرایش لندینگ",
            url: "/LandingsManage/editLanding",
          },
        ],
      }}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", height: "100%", mb: 5 }}
      >
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span  4"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  4"}>
            <TextField
              fullWidth
              value={state.moreTitle ? state.moreTitle : ""}
              label="عنوان لینک"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, moreTitle: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  6"}>
            <TextField
              fullWidth
              value={state.moreURL ? state.moreURL : ""}
              label="آدرس لینک"
              size="small"
              sx={{
                textarea: {
                  direction: "rtl",
                },
              }}
              multiline
              rows={2}
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, moreURL: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  6"}>
            <TextField
              fullWidth
              value={state.description ? state.description : ""}
              label="توضیحات"
              size="small"
              multiline
              rows={4}
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span  3"}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 5,
            }}
          >
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "55px", height: "auto" }}>
                  <Card
                    sx={{
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.url
                          ? imgState.url
                          : "/static/img/no-photos.png"
                      }
                    />
                  </Card>
                </Box>
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span  6"}
            sx={{ my: 2, display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateLandingBox(state, imgState.file, (calback) => {
                    setOffers(calback);
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/LandingsManage", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
        <LandingItems
          backUrl={"/LandingsManage/editLanding"}
          rows={items && items}
          modelID={state.id && state.id}
          model={location.state && location.state.model}
          LandingID={location.state && location.state.LandingID}
          LanID={location.state.LanID && location.state.LanID}
          callback={() => {
            GetLandingByID(state.id, (callback) => {
              setState({
                id: callback.id,
                aid: callback.aid,
                panelNO: callback.panelNO,
                title: callback.title,
                description: callback.description,
                moreTitle: callback.moreTitle,
                moreURL: callback.moreURL,
              });
              setItems(callback.items);
              setImgState({
                file: undefined,
                url: callback.icon ? callback.icon : "",
              });
            });
          }}
        />
      </Box>
    </Detail>
  );
}
